import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { title: String, body: String, url: String };

  connect() {
    if (window.__liveToastPermissionRequested !== true) {
      window.__liveToastPermissionRequested = true;
      this.requestPermission();
    }
  }

  show() {
    this.element.classList.remove("hidden");
    this.element.classList.add("animate-in");
    this.showBrowserNotification();
    this.timeout = window.setTimeout(() => this.dismiss(), 8000);
  }

  dismiss() {
    window.clearTimeout(this.timeout);
    this.element.remove();
  }

  async requestPermission() {
    if (!("Notification" in window)) return;
    if (Notification.permission === "default") {
      try {
        await Notification.requestPermission();
      } catch {
        // ignore
      }
    }
  }

  showBrowserNotification() {
    if (!("Notification" in window) || Notification.permission !== "granted") return;

    const notification = new Notification(this.titleValue, {
      body: this.bodyValue || undefined,
      icon: "/icon.png",
      tag: `miloffers-${Date.now()}`
    });

    notification.onclick = () => {
      window.focus();
      if (this.hasUrlValue && this.urlValue) {
        window.location.href = this.urlValue;
      }
      notification.close();
    };
  }
}
